import { brandAssets } from './brandAssets.js';

type Variant = 'jpg' | 'png';

interface Props {
  variant: Variant;
  displayWidth: number;
  className?: string;
}

export function SurgicalTechIllustration({ variant, displayWidth, className }: Props) {
  const src =
    variant === 'jpg'
      ? brandAssets.surgicalTech.jpg640
      : brandAssets.surgicalTech.png640;
  const intrinsic = brandAssets.surgicalTech.intrinsic;

  return (
    <img
      className={className}
      src={src}
      alt="ScrubLedger Surgical Technology illustration"
      width={intrinsic}
      height={intrinsic}
      loading="lazy"
      decoding="async"
      style={{ width: displayWidth, height: 'auto', maxWidth: '100%' }}
    />
  );
}
